<!--Header-->
<app-landingpage-header-child></app-landingpage-header-child>
<!-- End Header-->

<!-- Content -->
<div id="wrapper">

  <div id="content-wrapper" class="d-flex flex-column">
    <!-- Main Content -->
    <div id="content">
      <!-- Begin Page Content -->
      <div class="container-fluid">
        <!-- Content Row -->
        <div>
          <router-outlet></router-outlet>
        </div>
        <!-- Content Row -->
      </div>
      <!-- /.container-fluid -->
    </div>
    <!-- End of Main Content -->

    <!-- Footer -->
    <app-landingpage-footer></app-landingpage-footer>
    <!-- End of Footer -->
  </div>
  <!-- End of Content Wrapper -->
</div>
